import { XIcon } from 'lucide-react'
import { formatSalary } from '../../../../utils/formatSalary';
import { formatRelativeDate } from '../../../../utils/formatRelativeDate';

export function JobExpand({
    job,
    company,
    onClose,
}) {
    const keywords = typeof job.keywords === 'string'
        ? job.keywords.split(',').map(s => s.trim()).filter(Boolean)
        : Array.isArray(job.keywords) ? job.keywords : [];

    const benefits = typeof job.benefits_and_perks === 'string'
        ? job.benefits_and_perks.split(',').map(s => s.trim()).filter(Boolean)
        : Array.isArray(job.benefits_and_perks) ? job.benefits_and_perks : [];

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-300/20 backdrop-blur-md p-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-6 flex justify-between items-center rounded-t-lg">
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
                        {job.title}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 focus:outline-none"
                        aria-label="Close modal"
                    >
                        <XIcon size={24} />
                    </button>
                </div>
                <div className="p-6 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 pb-4 border-b border-gray-200 dark:border-gray-700">
                        <InfoItem label="Salary" value={`$ ${formatSalary(job.salary_min)} - $ ${formatSalary(job.salary_max)}`} />
                        <InfoItem label="Job Mode" value={job.is_remote ? "Remote" : "On-site"} />
                        <InfoItem label="Job Type" value={job.job_type} />
                        <InfoItem label="Location" value={`${job.city}, ${job.country}, ${job.state}`} />
                    </div>
                    <div className="space-y-4 pb-4 border-b border-gray-200 dark:border-gray-700">
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">Description</h3>
                        <p className="text-gray-700 dark:text-gray-300">{job.description}</p>
                    </div>
                    <div className="space-y-4 pb-4 border-b border-gray-200 dark:border-gray-700">
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">Skills</h3>
                        <div className="flex flex-wrap gap-2">
                            {keywords.length > 0 ? keywords.map((skill, index) => (
                                <span
                                    key={index}
                                    className="px-3 py-1 bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300 rounded-full text-sm"
                                >
                                    {skill}
                                </span>
                            )) : <span className="text-gray-400 dark:text-gray-500">None</span>}
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-4 border-b border-gray-200 dark:border-gray-700">
                        <div className="space-y-2">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                                Requirements
                            </h3>
                            <InfoItem
                                label="Education"
                                value={job.degree_requirements}
                            />
                            <InfoItem
                                label="Experience"
                                value={job.years_of_experience}
                            />
                        </div>
                        <div className="space-y-2">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                                Additional Info
                            </h3>
                            <InfoItem
                                label="Visa Sponsorship"
                                value={job.visa_sponsor ? "Available" : "Not available"}
                            />
                            <InfoItem label="Posted" value={formatRelativeDate(job.created_at)} />
                        </div>
                    </div>
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                            Benefits & Perks
                        </h3>
                        <ul className="list-disc pl-5 space-y-1">
                            {benefits.length > 0 ? benefits.map((benefit, index) => (
                                <li key={index} className="text-gray-700 dark:text-gray-300">
                                    {benefit}
                                </li>
                            )) : <li className="text-gray-400 dark:text-gray-500">None</li>}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
const InfoItem = ({ label, value }) => {
    return (
        <div className="space-y-1">
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</p>
            <p className="text-gray-800 dark:text-gray-200">{value}</p>
        </div>
    )
}
